import { departmentApi } from './department.api';
import type { Department, DepartmentSearchParams } from '../model/types';
import type { SearchParams, Pagination } from '@/shared/lib';

export async function search(
  searchUrl: string,
  searchParams: SearchParams
): Promise<{ data: Department[]; metadata: Pagination }> {
  const { search, page, amount, sort, filter } = searchParams;
  const params: DepartmentSearchParams = {
    search: search ?? undefined,
    sort: sort?.sort ?? undefined,
    order: sort?.order,
    active: filter?.active !== undefined ? Boolean(filter.active) : undefined,
    page,
    limit: amount,
  };

  const result = await departmentApi.search(params);

  return {
    data: result.data,
    metadata: {
      total: result.metadata.total,
      page: result.metadata.page,
      itemsPerPage: result.metadata.itemsPerPage,
      totalPages: result.metadata.totalPages,
      isNextPage: result.metadata.page < result.metadata.totalPages,
      isPreviousPage: result.metadata.page > 1,
    },
  };
}
